export { default } from './language-switcher';
